"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObjectDeleteAction = exports.isObjectReplaceAction = exports.isObjectInsertAction = exports.OTActionName = void 0;
// Use words' first letter as the identifier to save network transmission bytes
var OTActionName;
(function (OTActionName) {
    OTActionName["NumberAdd"] = "NA";
    OTActionName["ListInsert"] = "LI";
    OTActionName["ListDelete"] = "LD";
    OTActionName["ListReplace"] = "LR";
    OTActionName["ListMove"] = "LM";
    OTActionName["ObjectInsert"] = "OI";
    OTActionName["ObjectDelete"] = "OD";
    OTActionName["ObjectReplace"] = "OR";
    OTActionName["SubType"] = "ST";
    OTActionName["TextInsert"] = "TI";
    OTActionName["TextDelete"] = "TD";
})(OTActionName = exports.OTActionName || (exports.OTActionName = {}));
function isObjectInsertAction(action) {
    return action.n === 'OI';
}
exports.isObjectInsertAction = isObjectInsertAction;
function isObjectReplaceAction(action) {
    return action.n === 'OR';
}
exports.isObjectReplaceAction = isObjectReplaceAction;
function isObjectDeleteAction(action) {
    return action.n === 'OD';
}
exports.isObjectDeleteAction = isObjectDeleteAction;
//# sourceMappingURL=interface.js.map